import script from "./YearMonthSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./YearMonthSelector.vue?vue&type=script&setup=true&lang=ts"

import "./YearMonthSelector.vue?vue&type=style&index=0&id=05b89702&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05b89702"]])

export default __exports__